<template>
  <!-- 下拉菜单-->
  <div class="wk-input wk-input-box dropDown-slt-box posi-relative">
    <span class="input-left-label">{{label}}</span>
    <!--下拉框的 显示框-->
    <div class="dropDown-title dropDown-slt posi-relative" @click="titleCliCk">
      <!-- 已选择某个选项 -->
      <p v-if="sltIndex" class="dropDown-title-name ft-size-16 dropDown-slt">{{sltInfo}}</p>
      <!-- 否则 未选择 -->
      <p v-else class="dropDown-title-placeholder ft-size-16 dropDown-slt">请选择{{label}}</p>
      <!-- 在 readonly 下 启用 -->
      <p v-if="readonly==='' || readonly" class="disabled posi-absolute"></p>
      <!-- 尾部 三角号 icon -->
      <p class="posi-absolute dropDown-title-sanjiao dropDown-slt">
        <img src="../../assets/img/dropdow-icon.png" class="dropDown-title-sanjiao dropDown-slt">
      </p>
    </div>
    <!--下拉框的选项-->
    <ul v-if="isShowBox" class="dropDown-item-list posi-absolute dropDown-slt" :style="styleCpt">
      <li v-for="(item,k) in dataList" @click="itemClick(k)" :key='k' :class="{active:k===sltIndex}"
        class="dropDown-item">
        <!-- 如果不是 国籍 -->
        <span v-if="type!='nationality'"> {{item}} </span>
        <!-- 如果是 国籍 -->
        <span v-else> {{item.dicName}} </span>
      </li>
    </ul>
    <!-- 右侧提示 -->
    <div class="right-tip posi-absolute flex-dire-center">
      <slot> </slot>
    </div>
  </div>
</template>

<script>
  export default {
    props: ['label', 'value', 'id', 'type', 'styleCpt', 'readonly'],
    mounted() {
      this.initHandler(this);
    },
    data() {
      return {
        dataList: '',
        sltInfo: '',
        sltIndex: '',
        isShowBox: false
      }
    },
    watch: {
      //检测绑定值的变化,实时更改对应状态
      value() {
        if (['payment', 'fixedDate', 'fixedDatePay','fixedWeek','cycleUnit'].includes(this.type)) {
          this.showSltInfo(this.value);
          // 如果 是定投周期,且值小于10
          if (this.type == 'fixedDate' && this.value && parseInt(this.value) < 10) {
            this.sltInfo = this.dataList[String(parseInt(this.value))];
            this.sltIndex = '0' + parseInt(this.value);
          }
        }
      },
      type(){
        this.initHandler(this);
      }
    },
    beforeDestroy() {
      window.removeEventListener('click', this.windowHanlderOfSlt);
    },
    methods: {
      // title 单击事件
      titleCliCk() {
        this.isShowBox = !this.isShowBox;
      },
      // 选择事件
      itemClick(k) {
        // 如果选择结果 和上次的 不一样
        if (this.sltIndex != k) {
          this.sltIndex = k;
          this.sltInfo = this.dataList[k];
          // 如果选择的是 国籍
          if (this.type == 'nationality') {
            this.sltInfo = this.dataList[k].dicName;
            this.sltIndex = this.dataList[k].dicValue;
          }
          // 如果是选择的是 定投周期
          if (this.type == 'fixedDate') {
            this.sltIndex.length < 2 ? this.sltIndex = '0' + this.sltIndex : '';
            this.sltInfo.length < 2 ? this.sltInfo = '0' + this.sltInfo : '';
          }
          this.isShowBox = false;
          this.$emit('input', this.sltIndex);
          this.$emit('change', this.sltIndex);
        }
      },
      // 清空已选择的值
      clearSltVal() {
        this.sltInfo = '';
        this.sltIndex = '';
      },
      // window 点击事件
      windowHanlderOfSlt(e) {
        let target = e.target;
        // 如果点击的 不是 title 和 item 都隐藏
        if (target.className.indexOf('dropDown-slt') < 0) {
          this.isShowBox = false;
        }
      },
      // 页面初始化数据
      initHandler(that) {
        // 正价类型 性别 学历 主要收入来源 职业
        if (['IDENTITY_TYPE', 'SEX', 'EDUCATION', 'USER_INCOME_SOURCE',
            'VOCATION', 'PAY_TAXES_FLAG','SPECIAL_PERSON_FLAG','ANNUAL_INCOME'].includes(that.type)) {
          //初始化 证件类型
          that.$axios_post('other/dictionary', {
            dicKey: that.type
          }).then((res) => {
            console.log('res类型',res);
            if (res.code == '00000000') {
              that.dataList = res.dataMap;
              if (that.value) {
                that.sltIndex = that.value;
                that.sltInfo = that.dataList[that.sltIndex];
              }
            }
          })
        } else if (that.type == 'nationality') { // 国籍
          that.$axios_post('other/dictionary/nationality').then((res) => {
            if (res.code == '00000000') {
              that.dataList = res.dataList;
              if (that.value) {
                that.dataList.map((val, k) => {
                  if (val.dicValue == that.value) {
                    that.sltIndex = that.value;
                    that.sltInfo = that.dataList[k].dicName;
                  }
                })
              }
            }
          })
        } else if (that.type == 'beneficiaryOrhold') { // 实际受益人 或 实际控制自然人
          that.dataList = {
            '0': '其他',
            '1': '本人'
          };
          if (that.value) {
            that.sltIndex = that.value;
            that.sltInfo = that.dataList[that.sltIndex];
          }
        }else if(that.type == 'yearIncome'){ //年收入
           that.dataList = {
            '0': '1万~10万',
            '1': '10万~20万',
            '2': '20万~50万',
            '3': '50万以上',
          };
          if (that.value) {
            that.sltIndex = that.value;
            that.sltInfo = that.dataList[that.sltIndex];
          }
        }else if (that.type == 'juershuhui') { // 巨额赎回
          that.dataList = {
            '0': '延期赎回',
            '1': '取消赎回'
          };
          if (that.value) {
            that.sltIndex = that.value;
            that.sltInfo = that.dataList[that.sltIndex];
          }
        }else if (that.type == 'juershuhui2') { // 巨额赎回
          that.dataList = {
            '0': '取消赎回',
            '1': '延期赎回'
          };
          if (that.value) {
            that.sltIndex = that.value;
            that.sltInfo = that.dataList[that.sltIndex];
          }
        } else if (that.type == 'fixedDate') { // 定投周期
          //小于10时写一位,为了排序不乱,需要在传值时进行处理
          that.dataList = {
            '1': '每月1日',
            '2': '每月2日',
            '3': '每月3日',
            '4': '每月4日',
            '5': '每月5日',
            '6': '每月6日',
            '7': '每月7日',
            '8': '每月8日',
            '9': '每月9日',
            '10': '每月10日',
            '11': '每月11日',
            '12': '每月12日',
            '13': '每月13日',
            '14': '每月14日',
            '15': '每月15日',
            '16': '每月16日',
            '17': '每月17日',
            '18': '每月18日',
            '19': '每月19日',
            '20': '每月20日',
            '21': '每月21日',
            '22': '每月22日',
            '23': '每月23日',
            '24': '每月24日',
            '25': '每月25日',
            '26': '每月26日',
            '27': '每月27日',
            '28': '每月28日',
          };
          that.showSltInfo(that.value);
        }else if (that.type == 'fixedWeek') { // 定投周期
          that.dataList = {
            '2': '每周一',
            '3': '每周二',
            '4': '每周三',
            '5': '每周四',
            '6': '每周五',
          };
          that.showSltInfo(that.value);
        }else if (that.type == 'cycleUnit') { // 周期
          that.dataList = {
            '0': '每月',
            '1': '每周'
          };
          that.showSltInfo(that.value);
        }  else if (that.type == 'payment') { // 支付方式
          that.dataList = {
            '1': '薪意保',
            '2': '银行卡'
          };
          that.showSltInfo(that.value);
        } else if (that.type == 'fixedDatePay') { // 支付方式 (定投)
          that.dataList = {
            '2': '银行卡'
          };
          that.showSltInfo(that.value);
        } else if (that.type == 'redeemType') { // 赎回方式
          that.dataList = {
            '0': '普通赎回',
            '3': '快速赎回'
          };
          that.showSltInfo(that.value);
        } else if (that.type == 'language') { // 语言选择
          that.dataList = {
            '0': '中文版',
            '1': '英文版',
            '2': '中英文版'
          };
          that.showSltInfo(that.value);
        }
        // 绑定 window 事件 
        window.addEventListener('click', that.windowHanlderOfSlt);
      },
      // 显示的默认选中的信息
      showSltBank(that) {
        if (that.value) {
          // 遍历出当前的 默认选中的 信息
          that.bankList.map((val, k) => {
            if (val.bankCode == that.value.bankCode) {
              that.sltIndex = k;
              that.sltInfo = val;

            }
          })
        }
      },
      // 显示 已选中的 回显的值
      showSltInfo(val) {
        if (val) {
          this.sltIndex = val;
          this.sltInfo = this.dataList[this.sltIndex];
        }
      }
    }
  }

</script>

<style scoped lang="less">
  .dropDown-slt-box {
    margin: .9rem 0;

    // 下拉框的 title
    .dropDown-title {
      width: 17.3rem;
      height: 2.1rem;
      padding: 0 .8rem;
      line-height: 2rem;
      border: 1px solid #d1d1d1;
      overflow: hidden;
      cursor: pointer;

      // 未选择时提示
      .dropDown-title-placeholder {
        color: #cacaca;
      }

      // 已选择的 名称
      .dropDown-title-Name {
        position: absolute;
        top: 0;
        left: 2.5rem;
        overflow: hidden;
      }

      // 已选择的 icon
      .dropDown-title-icon {
        max-width: 1.2rem;
        margin-top: .4rem;
      }

      // readonly 下启用
      p.disabled {
        top: 0;
        right: 0;
        width: 18.4rem;
        height: 2rem;
        background: rgba(245, 247, 250, .1);
        z-index: 3;
      }

      // 三角号的icon
      p:last-child {
        top: 0;
        right: 0;
        bottom: 0;
        width: 2rem;
        background: #F8F8F8;
        border-left: .05rem solid #D6D6D6;
        text-align: center;
      }
    }

    // 下拉选择项
    .dropDown-item-list {
      top: 2.5rem;
      right: -1.7rem;
      width: 19rem;
      min-height: 2.1rem;
      max-height: 11rem;
      overflow: auto;
      flex-wrap: wrap;
      background: #fff;
      border-bottom: .05rem solid rgb(187, 176, 176);
      box-shadow: 0 2px 9px 0 rgba(205, 200, 200, 0.48);
      z-index: 100;

      li {
        display: block !important;
        height: 2.1rem;
        line-height: 2.1rem;
        padding: 0 .8rem;
        border: .05rem solid rgb(187, 176, 176);
        border-bottom: .05rem solid transparent;
        cursor: pointer;
        transition: all .2s linear;
      }

      li:hover,
      li.active {
        border: .05rem solid #DD867E;
        background: #FFF0EE;
      }

      li:hover+li,
      li.active+li {
        border-top: .05rem solid transparent;
      }
    }

    // 右侧提示
    .right-tip {
      top: 0;
      left: 100%;
      bottom: .1rem;
      padding-left: .5rem;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/BaseCpts/wkSelect.vue